import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
} from "@material-ui/core";
import React from "react";

const EntityInfoDialog = (props) => {
	const { title, open, setOpen, content } = props;
	return (
		<Dialog
			open={open}
			maxWidth="xl"
			onClose={() => setOpen(false)}
			aria-labelledby="confirm-dialog"
			className="backdrop"
		>
			<DialogTitle id="confirm-dialog">{title}</DialogTitle>
			<DialogContent>{content}</DialogContent>
			<DialogActions>
				<Button
					variant="outlined"
					color="secondary"
					onClick={() => {
						setOpen(false);
					}}
				>
					Cancelar
				</Button>
			</DialogActions>
		</Dialog>
	);
};
export default EntityInfoDialog;
